import { render } from "./RewardTile.vue?vue&type=template&id=33c8a1ba&scoped=true"
import script from "./RewardTile.vue?vue&type=script&lang=js"
export * from "./RewardTile.vue?vue&type=script&lang=js"

import "./RewardTile.vue?vue&type=style&index=0&id=33c8a1ba&scoped=true&lang=scss"

import exportComponent from "/home/forge/hostess.posnania.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c8a1ba"]])

export default __exports__